import initialstate from '../../initialstate';
import {SET_FORM_DETAILS, UPDATE_ACTIVE_FRAME, IS_DRAWER_COLLAPSED} from '../../../actions/actiontypes';
import {normalize} from '../../../util/utils';
import _ from 'lodash';
export default function DrawerFormDetailsReducer(state = initialstate.formDetailsOpenedInDrawer, action) {
	switch (action.type) {
		case SET_FORM_DETAILS: {
			let newState;
			const formDetails = _.cloneDeep(state);
			if (formDetails && Array.isArray(formDetails.allIds) && formDetails.allIds.length > 0) {
				formDetails.allIds.forEach((id) => {
					const formdetail = formDetails.byId[id];
					formdetail.isActiveFrame = false;
				});
				newState = normalize(action.response.detail, 'frameKey', formDetails);
			} else {
				newState = normalize(action.response.detail, 'frameKey', state);
			}

			return {
				...newState,
				isDrawerCollapsed: false
			};
		}
		case UPDATE_ACTIVE_FRAME: {
			const activeFrameformDetails = _.cloneDeep(state);
			if (activeFrameformDetails && Array.isArray(activeFrameformDetails.allIds)) {
				activeFrameformDetails.allIds.forEach((id) => {
					const formdetail = activeFrameformDetails.byId[id];
					if (action.response.isFrameClose && id === action.response.frameKey) {
						formdetail.isActiveFrame = false;
					}
					if (!action.response.isFrameClose) {
						formdetail.isActiveFrame = id === action.response.frameKey;
					}
				});
				return {
					...activeFrameformDetails,
					isDrawerCollapsed: activeFrameformDetails?.isDrawerCollapsed
				};
			}
			break;
		}
		case IS_DRAWER_COLLAPSED: {
			const response = action.response;
			return {
				...state,
				isDrawerCollapsed: response
			};
		}
		default:
			return state;
	}
}
